import { AppModels } from './components/app-models';
import { AppProviders } from './components/app-providers';
import { ErrorBoundary } from './components/error-boundary';
import { useAnalytics } from './hooks/use-analyze';
import { Skeleton } from '@/client/components/ui/skeleton';
import { useInitApp } from '@/client/hooks/use-init-app';
import { AppRouter } from '@/client/router';
import { memo, Suspense } from 'react';

const AppInitializer = memo(() => {
  useInitApp();
  useAnalytics();
  return null;
});

AppInitializer.displayName = 'AppInitializer';

/** Cold-load app-shell placeholder: a header bar + a grid of card-shaped
 *  skeletons instead of a bare centered spinner, so the layout has structure
 *  before the app chunks resolve. */
const AppShellSkeleton = () => (
  <div className="min-h-screen w-full">
    <div className="mx-auto w-full max-w-[1200px] px-4 py-6 md:px-6">
      <Skeleton className="mb-8 h-10 w-64" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-48 w-full" />
        ))}
      </div>
    </div>
  </div>
);

const App = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<AppShellSkeleton />}>
        <AppProviders>
          <AppInitializer />
          <AppRouter />
          <AppModels />
        </AppProviders>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
